import CommonResponseWithPlayerAuthInfo from "../../models/CommonResponseWithPlayerAuthInfo";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function tryToDoLoginWithSteamReturnInfo(client: BackendClient, steamReturnInfo: string): Promise<CommonResponseWithPlayerAuthInfo> {
    return new Promise<CommonResponseWithPlayerAuthInfo>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.LoginWithSteamReturnInfoPath}${steamReturnInfo}`)
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to do login with steam return info: ${JSON.stringify(reason)} - ${reason}`)
          reject(reason);
        });
    });
  }